export class ContainerReturnLandingFilterVM {
  accountName: string;
  accountNo: string;
  itemNo: string;
  lotSerialNo: string;
  productName: string;
  requestDate: any;
  returnId: string;
  customerPO: string;
}
